import { render, staticRenderFns } from "./ManagePatient.vue?vue&type=template&id=f317f21e&scoped=true"
import script from "./ManagePatient.vue?vue&type=script&lang=js"
export * from "./ManagePatient.vue?vue&type=script&lang=js"
import style0 from "./ManagePatient.vue?vue&type=style&index=0&id=f317f21e&prod&scoped=true&lang=css"
import style1 from "./ManagePatient.vue?vue&type=style&index=1&id=f317f21e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f317f21e",
  null
  
)

export default component.exports